import swal from 'sweetalert'

/* @ngInject */
function notificationsCentralService ($rootScope, $state, $translate, $q, $window, ArtsService, MessageService, ModalService, SliderService, AssetPreviewService, NotificationsService, UdsModalService, TasksService) {
  const _getRequestDetailsDialogController = () => $q.when(import('../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const _getSubtaskDetailsDialogController = () => $q.when(import('../../workflow/dialogs/subtask-details/subtask-details-dialog.controller'))
  const _getAuditDetailDialogController = () => $q.when(import('../../audit/dialogs/audit-detail/audit-detail-dialog.controller'))
  let notificationBarIsOpen = false

  const service = {
    _getRequestDetailsDialogController,
    _getSubtaskDetailsDialogController,
    _getAuditDetailDialogController,
    _openApprovalDialog,
    init,
    open,
    close,
    getNotificationFrom,
    handleNotification,
    isOpen
  }
  return service

  function init () {
    const textObject = localStorage.getItem('notification')

    if (textObject) {
      localStorage.removeItem('notification')

      const parsedObject = JSON.parse(textObject)
      service.handleNotification(parsedObject)
    }
  }

  function open (reloadNotifications) {
    if (!notificationBarIsOpen) {
      notificationBarIsOpen = true
      $rootScope.$broadcast('loadInitialNotifications', reloadNotifications)
      $rootScope.$broadcast('notificationBarToggle', true)
      jQuery('.notifications-central').transition('slide right')
      jQuery('body').css('overflow', 'hidden')
    }
  }

  function close () {
    if (notificationBarIsOpen) {
      notificationBarIsOpen = false
      $rootScope.$broadcast('notificationBarToggle', false)
      NotificationsService.clearNewNotifications().then(() => {
        $rootScope.$broadcast('reloadUnreadNotifications')
      })
      jQuery('.notifications-central').transition('slide right')
      jQuery('body').css('overflow', '')
    }
  }

  function isOpen () {
    return notificationBarIsOpen
  }

  function getNotificationFrom (notification) {
    if (notification.type === 'NEW_USER_NEEDS_ACTIVATION' || notification.type === 'USER_ACCEPTED_INVITE') {
      return 'user'
    }
    if (['NEW_AUDIT', 'USER_COMENTED_ON_AUDIT', 'AUDIT_FILLED', 'AUDIT_RATED', 'AUDIT_RATED_ACTION', 'AUDIT_FINISHED', 'AUDIT_NONCONFORM', 'AUDIT_RESPONSE_AWAITING', 'REPLY_CHECKLIST_REMINDER', 'ADJUST_CHECKLIST_REMINDER'].includes(notification.type)) {
      return 'audit'
    }
    if (['ART_NEEDS_APPROVAL', 'ART_NEEDS_REWORK', 'ART_APPROVED', 'ADDED_MESSAGE_TO_APPROVAL', 'UPDATED_APPROVAL_COMENT', 'ART_REJECTED', 'USER_COMMENT_APPROVAL', 'ADJUST_ART_REMINDER', 'USE_APPROVED_ART_REMINDER'].includes(notification.type)) {
      return 'art'
    }
    if (['USER_ASSIGNED_TO_TASK', 'UPDATED_TASK_PRIORITY', 'USER_COMENTED_ON_TASK', 'NEW_BRIEFING', 'TASK_DONE', 'TASK_PROGRESS', 'TASK_WAITING_USER_ADJUST', 'TASK_REJECTED', 'TASK_WAITING_RESPONSE', 'TASK_REVIEW', 'TASK_WAITING_ADM_ADJUST', 'TASK_REVIEW_APPROVED', 'TASK_ARCHIVED', 'ASSET_COMENT', 'MENTION_WORKFLOW', 'MENTION_ASSET', 'TASK_APPROVED_INBOX', 'READ_REQUEST_COMMENT_REMINDER', 'ADJUST_REQUEST_REMINDER', 'REVIEW_REQUEST_REMINDER', 'USE_FINISHED_REQUEST_REMINDER', 'NEW_INTERNAL_APPROVAL', 'INTERNAL_APPROVAL_STATUS_UPDATE'].includes(notification.type)) {
      return 'task'
    }
    if (['NEW_POST', 'READ_ANNOUNCEMENT_REMINDER'].includes(notification.type)) {
      return 'post'
    }
    if (['CAMPAIGN_ACTIONS_PUBLISHED', 'CAMPAIGN_ACTIONS_EXPIRATION_REMINDER', 'CAMPAIGN_DELIVERY_DATE_TOMORROW_REMINDER', 'CAMPAIGN_STARTS_TOMORROW_REMINDER', 'CAMPAIGN_EMPTY_AFTER_2_DAYS_REMINDER', 'CAMPAIGN_HAS_STARTED'].includes(notification.type)) {
      return 'campaign'
    }
    if (notification.type === 'SOCIAL_MEDIA_LIKE') {
      return 'socialMediaLike'
    }
  }

  function handleNotification (notification) {
    const from = service.getNotificationFrom(notification)

    if (from === 'user') {
      $state.go('admin.users')
    } else if (from === 'audit') {
      service._getAuditDetailDialogController().then(({ AuditDetailDialogController }) => {
        ModalService.showModal({
          controller: AuditDetailDialogController,
          templateId: 'auditDetail.html',
          templateUrl: '/audit/dialogs/audit-detail/audit-detail-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          data: {
            id: notification.audit.id
          }
        })
      })
    } else if (from === 'art') {
      _openApprovalDialog(notification.art)
    } else if (notification.type === 'ART_SHARED') {
      if (notification.art.needApproval && notification.art.approvalStatus === 'APPROVED' && $rootScope.isUser()) {
        MessageService.warning({
          title: $translate.instant('warning'),
          text: $translate.instant('editApprovedArtMsg'),
          confirmButton: $translate.instant('edit'),
          cancelButton: $translate.instant('cancel'),
          press: () => {
            swal.close()
            ArtsService.sendArtToDesiging(notification.art.id).then(function () {
              $state.go('customizeArt', {
                idArt: notification.art.id,
                from: $state.current.name,
                fromParams: $state.params
              })
            })
          },
          allowOutsideClick: false,
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        })

        return
      }

      $state.go('customizeArt', {
        idArt: notification.art.id,
        fromParams: $state.params
      })
    } else if (from === 'task') {
      TasksService.getTaskById(notification.task.id).then((task) => {
        if (task.originType === 'SUBTASK') {
          service._getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
            const modal = UdsModalService.createModal({
              controller: SubtaskDetailsDialogController,
              modalName: 'subtaskDetailsDialog',
              data: {
                subtask: task
              }
            })
            modal.open()
          })
        } else {
          service._getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
            const modal = UdsModalService.createModal({
              controller: RequestDetailsDialogController,
              modalName: 'requestDetailsDialog',
              data: {
                id: notification.task.id
              }
            })
            modal.open()
          })
        }
      })
    } else if (from === 'post') {
      if ($rootScope.isDesktop) {
        ModalService.showModal({
          templateId: 'newPost.html',
          templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
          destroyable: true,
          closable: true,
          data: {
            _postId: notification.postId,
            _editMode: false,
            _existingPost: true,
            _openedByNotification: true
          }
        })
      } else {
        SliderService.setState('post-slider', 'open', {
          _postId: notification.postId,
          _editMode: false,
          _existingPost: true
        })
      }
    } else if (from === 'socialMediaLike') {
      const publicUrl = notification.content.publicUrl

      if (publicUrl) {
        $window.open(publicUrl, '_blank', 'noopener noreferrer')
      }
    } else if (from === 'campaign') {
      if ($rootScope.isUserSysAdminAdmin()) {
        $state.go('campaigns-edit', {
          id: notification.campaign.id,
          activeTab: notification.type === 'CAMPAIGN_HAS_STARTED' ? 'tab-7' : null
        })
      } else {
        $state.go('user.arts')
      }
    }
  }

  function _openApprovalDialog (asset) {
    AssetPreviewService.openAssetPreview({
      asset,
      location: 'materialsApproval',
      getPreviewAssets: () => {
        return Promise.resolve({
          count: 1,
          assets: [asset]
        })
      }
    })
  }
}

export { notificationsCentralService }
